import TopicPage from '../components/TopicPage';

const sections = [
  {
    title: 'Language Fundamentals',
    icon: '📖',
    cards: [
      {
        icon: '🐍',
        title: 'Python Basics',
        level: 'beginner',
        description: 'Variables, data types, control flow, functions, and Python\'s dynamic typing system.',
        topics: ['Data types', 'List/Dict/Set', 'Comprehensions', 'Lambda'],
      },
      {
        icon: '🎭',
        title: 'OOP in Python',
        level: 'beginner',
        description: 'Classes, inheritance, dunder methods, properties, and Python\'s object model.',
        topics: ['Classes', 'Inheritance', '__init__', 'Decorators'],
      },
      {
        icon: '⚡',
        title: 'Async / Await',
        level: 'intermediate',
        description: 'Concurrency with asyncio — coroutines, event loops, tasks, and async context managers.',
        topics: ['asyncio', 'Coroutines', 'gather()', 'aiohttp'],
      },
      {
        icon: '🔧',
        title: 'Advanced Python',
        level: 'advanced',
        description: 'Generators, context managers, metaclasses, descriptors, and the data model.',
        topics: ['Generators', 'yield from', 'Metaclasses', '__slots__'],
      },
    ],
  },
  {
    title: 'Web Frameworks',
    icon: '🌐',
    cards: [
      {
        icon: '⚡',
        title: 'FastAPI',
        level: 'intermediate',
        description: 'Modern async web framework with automatic OpenAPI docs, Pydantic validation, and dependency injection.',
        topics: ['Pydantic', 'Depends()', 'Background tasks', 'WebSockets'],
      },
      {
        icon: '🎸',
        title: 'Django',
        level: 'intermediate',
        description: 'Batteries-included web framework. ORM, admin panel, authentication, and MTV architecture.',
        topics: ['ORM', 'Admin', 'Middleware', 'DRF'],
      },
      {
        icon: '🍶',
        title: 'Flask',
        level: 'beginner',
        description: 'Lightweight WSGI micro-framework. Minimal core with extensions for everything else.',
        topics: ['Blueprints', 'SQLAlchemy', 'Jinja2', 'Flask-RESTful'],
      },
    ],
  },
  {
    title: 'Data Science & ML',
    icon: '📊',
    cards: [
      {
        icon: '🐼',
        title: 'Pandas & NumPy',
        level: 'intermediate',
        description: 'Data manipulation and numerical computing. DataFrames, Series, array ops, and vectorization.',
        topics: ['DataFrame', 'groupby()', 'merge()', 'Broadcasting'],
      },
      {
        icon: '📈',
        title: 'Matplotlib & Seaborn',
        level: 'beginner',
        description: 'Data visualization libraries for creating static, animated, and interactive plots.',
        topics: ['pyplot', 'Subplots', 'Seaborn themes', 'Plotly'],
      },
      {
        icon: '🤖',
        title: 'Scikit-learn',
        level: 'intermediate',
        description: 'ML library with consistent API for classification, regression, clustering, and model evaluation.',
        topics: ['Pipeline', 'Cross-validation', 'GridSearchCV', 'Transformers'],
      },
    ],
  },
  {
    title: 'DevOps & Tooling',
    icon: '🛠️',
    cards: [
      {
        icon: '📦',
        title: 'Packaging',
        level: 'intermediate',
        description: 'Virtual environments, packaging with pyproject.toml, publishing to PyPI, and dependency management.',
        topics: ['venv', 'pip', 'Poetry', 'pyproject.toml'],
      },
      {
        icon: '🧪',
        title: 'Testing',
        level: 'intermediate',
        description: 'pytest ecosystem — fixtures, mocking, parameterize, coverage, and test-driven development.',
        topics: ['pytest', 'Fixtures', 'Mock', 'coverage.py'],
      },
      {
        icon: '🐳',
        title: 'Python in Containers',
        level: 'intermediate',
        description: 'Dockerize Python apps efficiently with multi-stage builds, slim images, and best practices.',
        topics: ['Multi-stage', 'python:slim', 'gunicorn', '.dockerignore'],
      },
    ],
  },
];

function Python() {
  return (
    <TopicPage
      title="Python"
      subtitle="From scripting to systems — a comprehensive guide to Python development."
      icon="🐍"
      color="#3776ab"
      sections={sections}
    />
  );
}

export default Python;
